import {BioentitySummary} from 'folder-items/FileConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

export const BULK_ANTIBODY_SCREEN = 'BULK_ANTIBODY_SCREEN';

export enum Step {
  BULK_TRANSLATION = 'BULK_TRANSLATION',
  BULK_ANTIBODY = 'BULK_ANTIBODY',
}

export interface BioentityLinkSpec {
  tagSchemaField: SchemaField;
  files: Array<BioentitySummary>;
}

export interface ForServerBFITag {
  targetFiles: Array<{id: string}>;
}

export interface BFITag {
  targetFiles: Array<{id: string; name: string}>;
  value: string;
}

type Tag = BFITag | ForServerBFITag;

export interface BFISpec<TTag extends Tag> {
  name: string;
  tags: Record<string, TTag>;
}

export interface BulkAntibody {
  step: Step;
  tagSchemaId?: string;
  antibodyNamePrefix: string;
  outputFolderId?: string;
  bioentityLinkSpecs: Array<BioentityLinkSpec>;
  inputFiles: Array<BioentitySummary>;
  inputFilesLoading: boolean;
  isCreating: boolean;
}
